import React from "react";
import { buildWaUrl, SITE } from "../data/site";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFloat({ message }) {
  return (
    <a
      href={buildWaUrl(message)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="wa-float-btn"
      aria-label={`Chat WhatsApp ${SITE.name}`}
      className="fixed z-50 bottom-5 right-5 md:bottom-7 md:right-7"
    >
      <span className="relative inline-flex">
        <span className="absolute inset-0 rounded-full pulse-ring" />
        <span className="relative inline-flex items-center gap-2 bg-[#25D366] text-white font-semibold rounded-full pl-4 pr-5 py-3 shadow-[0_10px_30px_rgba(37,211,102,0.4)] wa-pulse hover:scale-[1.04] transition-transform">
          <MessageCircle className="w-5 h-5" strokeWidth={2.5} />
          <span className="hidden sm:inline text-sm">Chat WhatsApp</span>
        </span>
      </span>
    </a>
  );
}
